@if (jobStatusTrackerFeatureEnabled || notifications.length) {
  <button class="notification-icon" (click)="toggleNotificationPopover()">
    <svg-helper svgName="bell"></svg-helper>
    @if (unreadNotificationCount) {
      <span class="notification-badge">{{unreadNotificationCount}}</span>
    }
  </button>
}
@if (showNotificationPopover) {
  <div class="notification-popover">
    <div class="notification-title">Notifications</div>
    @if (loading) {
      <mat-spinner diameter="50"></mat-spinner>
    }
    @if (!loading) {
      <div class="notification-popover-content">
        @if (!jobsThatNeedAttention.length && !notifications.length) {
          <div class="no-notifications">All Clear!</div>
        }
        @for (notification of notifications; track notification) {
          <div class="notification-item" [innerHtml]="notification.Content | safeHtml" (click)="handleNotificationClick(notification.Id)"></div>
        }
        @for (job of jobsThatNeedAttention; track job) {
          <div class="notification-item">{{job.JobId}} - {{job.JobName}}: Needs Attention<br /><a [routerLink]="['/orders/history/jobs/details', { jobId: job.JobId}]">Click here</a> to view the job</div>
        }
      </div>
    }
  </div>
}